import React, { useEffect, useState, useRef } from "react";
import "./GenerateReport.scss";
import { Icon } from "@iconify/react";
import AutoChart from "./Charts/AutoChart/AutoChart";
import OverAllChart from "./Charts/OverAllChart/OverAllChart";
import PolarChart from "./Charts/PolarChart/PolarChart";
import MetricsChart from "./Charts/MetricsChart/MetricsChart";
import SplimeChart from "./Charts/SplimeChart/SplimeChart";
import { useReactToPrint } from 'react-to-print';

// import ourBrand from "../../BrandComparison/ourBrand.json";
// console.log("ddd", ourBrand);
const GenerateReport = ({ ourBrand }) => {
  const [scoring, setScoring] = useState({});
  const reportRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => reportRef.current,
  });

  const getPageMarginsF = () => {
    return `@page :first { margin: ${"0px"} ${"0px"} ${"10px"} ${"0px"} !important; }`;
  };
  const getPageMargins = () => {
    return `@page { margin: ${"30px"} ${"30px"} ${"30px"} ${"30px"} !important; }`;
  };
  const getPageMarginss = () => {
    return `@print { .removeDuringPrint{ display: none;} }`;
  };
  const getPageMarginst = () => {
    return `table { page-break-inside: avoid; }`;
  };
  useEffect(() => {
    console.log("kjhgkjh", ourBrand);
  }, [])

  return (
    <div className="GenerateReport-container customScroller">
      <div className="GenerateReport-inner-container">
        <h3 className="pb-2">Your report is ready to view
          <button style={{ backgroundColor: "#93393C", color: "white", marginLeft: "20px", borderRadius: "5px", padding: "5px", fontSize: "16px" }} onClick={handlePrint}>Save PDF</button></h3>
        <style>{getPageMarginss()}</style>
        <style>{getPageMargins()}</style>
        <style>{getPageMarginst()}</style>
        {/* <div className="GenerateReport-SalesRevenue-container">
              <h5>Sales and Revenue</h5>
              <div className="salesAndRevenue-main-container">
                <div className="salesAndRevenue-left-container">
                  <p>
                    Proin id risus finibus Vivamus pulvinar 5% augue non dui sodales
                    dapibus eget diam nec bibendum. Sed blandit tincidunt dui.
                    Pellentesque vel diam quis nisl laoreet consequat id vitae
                    massa. Mauris tempor nunc ut pellentesque interdum. Integer
                    sollicitudin sed est eu ultricies.
                  </p>
                  <table>
                    <thead>
                      <tr>
                        <th></th>
                        <th>Sales</th>
                        <th>Revenue</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td className="areaSale">Aliquam</td>
                        <td className="areaSalePerc">40%</td>
                        <td className="areaSalerevenue">45%</td>
                      </tr>
                      <tr>
                        <td className="areaSale">Gravida</td>
                        <td className="areaSalePerc">34%</td>
                        <td className="areaSalerevenue">48%</td>
                      </tr>
                      <tr>
                        <td className="areaSale">Eleifend</td>
                        <td className="areaSalePerc">20%</td>
                        <td className="areaSalerevenue">26%</td>
                      </tr>
                      <tr>
                        <td className="areaSale">Dapibus</td>
                        <td className="areaSalePerc">60%</td>
                        <td className="areaSalerevenue">72%</td>
                      </tr>
                      <tr>
                        <td className="areaSale">Efficitur</td>
                        <td className="areaSalePerc">44%</td>
                        <td className="areaSalerevenue">54%</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div className="salesAndRevenue-right-container">
                  <AutoChart />
                </div>
              </div>
            </div> */}

        <div className="GenerateReport-fourGridStats-container" ref={reportRef}>
          <div className="GenerateReport-fourGridStats-box removeDuringPrint">
            <h5>Rating Distribution</h5>
            {!ourBrand.reviews ? <p>
              This Brand doesn't have enough online presence or reviews.
            </p>
              :
              ""}
            {ourBrand.reviews ?
              <div className="BrandVisibilityMetrics-container">
                <div className="d-flex justify-content-between mb-2">
                  <span className="BrandVisibilityMetrics-text-name">
                    5 Stars
                  </span>
                  <span className="BrandVisibilityMetrics-yellow-line">
                    <span
                      className="BrandVisibilityMetrics-yellow-lineChild"
                      style={{
                        width: `${((ourBrand.reviews &&
                          ourBrand.reviews.reviewDistribution &&
                          ourBrand.reviews.reviewDistribution["5"]) /
                          (ourBrand.reviews && ourBrand.reviews.totalReviews)) *
                          100
                          }%`,
                      }}
                    >
                      {" "}
                    </span>
                  </span>
                  <span className="BrandVisibilityMetrics-text-percentage">
                    {ourBrand.reviews &&
                      ourBrand.reviews.reviewDistribution &&
                      ourBrand.reviews.reviewDistribution["5"]}
                  </span>
                </div>
                <div className="d-flex justify-content-between mb-2">
                  <span className="BrandVisibilityMetrics-text-name">
                    4 Stars
                  </span>
                  <span className="BrandVisibilityMetrics-lightRed-line">
                    <span
                      className="BrandVisibilityMetrics-lightRed-lineChild"
                      style={{
                        width: `${((ourBrand.reviews &&
                          ourBrand.reviews.reviewDistribution &&
                          ourBrand.reviews.reviewDistribution["4"]) /
                          (ourBrand.reviews && ourBrand.reviews.totalReviews)) *
                          100
                          }%`,
                      }}
                    >
                      {" "}
                    </span>
                  </span>
                  <span className="BrandVisibilityMetrics-text-percentage">
                    {ourBrand.reviews &&
                      ourBrand.reviews.reviewDistribution &&
                      ourBrand.reviews.reviewDistribution["4"]}
                  </span>
                </div>
                <div className="d-flex justify-content-between mb-2">
                  <span className="BrandVisibilityMetrics-text-name">
                    3 Stars
                  </span>
                  <span className="BrandVisibilityMetrics-xinc-line">
                    <span
                      className="BrandVisibilityMetrics-xinc-lineChild"
                      style={{
                        width: `${((ourBrand.reviews &&
                          ourBrand.reviews.reviewDistribution &&
                          ourBrand.reviews.reviewDistribution["3"]) /
                          (ourBrand.reviews && ourBrand.reviews.totalReviews)) *
                          100
                          }%`,
                      }}
                    ></span>
                  </span>
                  <span className="BrandVisibilityMetrics-text-percentage">
                    {ourBrand.reviews &&
                      ourBrand.reviews.reviewDistribution &&
                      ourBrand.reviews.reviewDistribution["3"]}
                  </span>
                </div>
                <div className="d-flex justify-content-between mb-2">
                  <span className="BrandVisibilityMetrics-text-name">
                    2 Stars
                  </span>
                  <span className="BrandVisibilityMetrics-blue-line">
                    <span
                      className="BrandVisibilityMetrics-blue-lineChild"
                      style={{
                        width: `${((ourBrand.reviews &&
                          ourBrand.reviews.reviewDistribution &&
                          ourBrand.reviews.reviewDistribution["2"]) /
                          (ourBrand.reviews && ourBrand.reviews.totalReviews)) *
                          100
                          }%`,
                      }}
                    ></span>
                  </span>
                  <span className="BrandVisibilityMetrics-text-percentage">
                    {ourBrand.reviews &&
                      ourBrand.reviews.reviewDistribution &&
                      ourBrand.reviews.reviewDistribution["2"]}
                  </span>
                </div>
                <div className="d-flex justify-content-between mb-2">
                  <span className="BrandVisibilityMetrics-text-name">1 Star</span>
                  <span className="BrandVisibilityMetrics-blue-line">
                    <span
                      className="BrandVisibilityMetrics-blue-lineChild"
                      style={{
                        width: `${((ourBrand.reviews &&
                          ourBrand.reviews.reviewDistribution &&
                          ourBrand.reviews.reviewDistribution["1"]) /
                          (ourBrand.reviews && ourBrand.reviews.totalReviews)) *
                          100
                          }%`,
                        backgroundColor: "cadetblue",
                      }}
                    ></span>
                  </span>
                  <span className="BrandVisibilityMetrics-text-percentage">
                    {ourBrand.reviews &&
                      ourBrand.reviews.reviewDistribution &&
                      ourBrand.reviews.reviewDistribution["1"]}
                  </span>
                </div>
              </div>
              :
              ""}
          </div>

          <div
            className="GenerateReport-fourGridStats-box"
            style={{ height: "100%" }}
          >
            <h5>Average Social Media Metrics</h5>
            <p>
              Below are the social stats of the recent posts of the{" "}
              {ourBrand.instagramResults &&
                ourBrand.instagramResults.profileData &&
                ourBrand.instagramResults.profileData.name}
            </p>

            <table className="SocialMediaMetrics-table">
              <thead>
                <tr>
                  <th>Activities</th>
                  <th>Instagram</th>
                  {/* <th>X</th>
                                    <th>Facebook</th> */}
                  {/* <th>LinkedIn</th> */}
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Followers</td>
                  <td>
                    {ourBrand.instagramResults &&
                      ourBrand.instagramResults.profileData &&
                      ourBrand.instagramResults.profileData.followers}
                  </td>
                  {/* <td>84K</td>
                                    <td>140K</td>
                                    <td>77K</td> */}
                </tr>
                <tr>
                  <td>Likes</td>
                  <td>
                    {ourBrand.instagramResults &&
                      ourBrand.instagramResults.postData &&
                      Math.round(
                        ourBrand.instagramResults.postData.reduce(
                          (total, post) => total + post.instaLikes,
                          0
                        ) / ourBrand.instagramResults.postData.length
                      )}
                  </td>
                  <td></td>
                  {/* <td>45K</td>
                                    <td>32K</td> */}
                </tr>
                <tr>
                  <td>Comments</td>
                  <td>
                    {ourBrand.instagramResults &&
                      ourBrand.instagramResults.postData &&
                      Math.round(
                        ourBrand.instagramResults.postData.reduce(
                          (total, post) => total + post.instaComments,
                          0
                        ) / ourBrand.instagramResults.postData.length
                      )}
                  </td>
                  {/* <td>150</td>
                                    <td>369</td>
                                    <td>89</td> */}
                </tr>
              </tbody>
            </table>
            <div className="keyProductFeatures" style={{ marginTop: "7px" }}>
              <h5>Social Analytics</h5>

              <ul>
                <h6>Audience Engagement Analysis</h6>
                {ourBrand.mainAnalysis &&
                  ourBrand.mainAnalysis.brandInformation &&
                  ourBrand.mainAnalysis.brandInformation
                    .socialAnalysis
                  &&
                  ourBrand.mainAnalysis.brandInformation
                    .socialAnalysis
                    .audienceEngagementAnalysis
                  ? ourBrand.mainAnalysis.brandInformation.socialAnalysis
                    .audienceEngagementAnalysis.map(
                      (feature) => (
                        <li>
                          <Icon
                            icon="solar:map-arrow-right-bold-duotone"
                            width="15"
                            height="15"
                          />
                          {feature}
                        </li>
                      )
                    )
                  : "Some Error Occured"}
              </ul>

              <ul style={{ marginTop: "7px" }}>
                <h6>Social Content Analysis</h6>
                {ourBrand.mainAnalysis &&
                  ourBrand.mainAnalysis.brandInformation &&
                  ourBrand.mainAnalysis.brandInformation
                    .socialAnalysis
                  &&
                  ourBrand.mainAnalysis.brandInformation
                    .socialAnalysis
                    .contentAnalysis

                  ? ourBrand.mainAnalysis.brandInformation.socialAnalysis
                    .contentAnalysis
                    .map(
                      (feature) => (
                        <li>
                          <Icon
                            icon="solar:map-arrow-right-bold-duotone"
                            width="15"
                            height="15"
                          />
                          {feature}
                        </li>
                      )
                    )
                  : "Some Error Occured"}
              </ul>

              <ul style={{ marginTop: "7px" }}>
                <h6>Social Content Frequency Analysis</h6>
                {ourBrand.mainAnalysis &&
                  ourBrand.mainAnalysis.brandInformation &&
                  ourBrand.mainAnalysis.brandInformation
                    .socialAnalysis
                  &&
                  ourBrand.mainAnalysis.brandInformation
                    .socialAnalysis
                    .contentUploadingFrequencyAnalysis


                  ? ourBrand.mainAnalysis.brandInformation.socialAnalysis
                    .contentUploadingFrequencyAnalysis

                    .map(
                      (feature) => (
                        <li>
                          <Icon
                            icon="solar:map-arrow-right-bold-duotone"
                            width="15"
                            height="15"
                          />
                          {feature}
                        </li>
                      )
                    )
                  : "Some Error Occured"}
              </ul>

              <ul style={{ marginTop: "7px" }}>
                <h6>Response Rate Analysis</h6>
                {ourBrand.mainAnalysis &&
                  ourBrand.mainAnalysis.brandInformation &&
                  ourBrand.mainAnalysis.brandInformation
                    .socialAnalysis
                  &&
                  ourBrand.mainAnalysis.brandInformation
                    .socialAnalysis
                    .responseRate



                  ? ourBrand.mainAnalysis.brandInformation.socialAnalysis
                    .responseRate


                    .map(
                      (feature) => (
                        <li>
                          <Icon
                            icon="solar:map-arrow-right-bold-duotone"
                            width="15"
                            height="15"
                          />
                          {feature}
                        </li>
                      )
                    )
                  : "Some Error Occured"}
              </ul>

            </div>
          </div>

          <div className="GenerateReport-fourGridStats-box">
            <h5>Brand's Comparative Analysis</h5>
            <p>
              <div className="productAnalysisContent">
                <div className="keyProductFeatures">
                  <h5 style={{ backgroundColor: "#55335F" }}>Key Analysis Points</h5>
                  <ul>
                    {ourBrand.mainAnalysis &&
                      ourBrand.mainAnalysis.brandInformation &&
                      ourBrand.mainAnalysis.brandInformation
                        .comparativeAnalysis
                      &&
                      ourBrand.mainAnalysis.brandInformation
                        .comparativeAnalysis
                        .comparativeAnalysisPoints

                      ? ourBrand.mainAnalysis.brandInformation.comparativeAnalysis
                        .comparativeAnalysisPoints
                        .map(
                          (feature) => (
                            <li>
                              <Icon
                                icon="solar:map-arrow-right-bold-duotone"
                                width="20"
                                height="20"
                              />
                              {feature}
                            </li>
                          )
                        )
                      : "Some Error Occured"}
                  </ul>
                </div>
                {/* <div className="keyProductFeatures">
                  <h5>Interesting Product Differentiations</h5>
                  <ul>
                    {ourBrand.mainAnalysis &&
                      ourBrand.mainAnalysis.brandInformation &&
                      ourBrand.mainAnalysis.brandInformation
                        .productFeaturesAnalysis &&
                      ourBrand.mainAnalysis.brandInformation
                        .productFeaturesAnalysis.interestingProductDifferntiators
                      ? ourBrand.mainAnalysis.brandInformation.productFeaturesAnalysis.interestingProductDifferntiators.map(
                        (differntiators) => (
                          <li>
                            <Icon
                              icon="solar:map-arrow-right-bold-duotone"
                              width="20"
                              height="20"
                            />
                            {differntiators}
                          </li>
                        )
                      )
                      : "Some Error Occured"}
                  </ul>
                </div>
                <div className="keyProductFeatures">
                  <h5>Quotes about Product Features</h5>
                  <ul>
                    {ourBrand.mainAnalysis &&
                      ourBrand.mainAnalysis.brandInformation &&
                      ourBrand.mainAnalysis.brandInformation
                        .productFeaturesAnalysis &&
                      ourBrand.mainAnalysis.brandInformation
                        .productFeaturesAnalysis.citedQuotes && ourBrand.mainAnalysis.brandInformation.productFeaturesAnalysis.citedQuotes.length > 0
                      ? ourBrand.mainAnalysis.brandInformation.productFeaturesAnalysis.citedQuotes.map(
                        (citedQuote) => (
                          <li>
                            <Icon
                              icon="solar:map-arrow-right-bold-duotone"
                              width="20"
                              height="20"
                            />
                            {citedQuote && citedQuote.quote
                              ? citedQuote.quote
                              : "Error Fecthing Quotes"}
                            <em>
                              {citedQuote &&
                                citedQuote.quote &&
                                citedQuote.source
                                ? " - "
                                : ""}
                              {citedQuote && citedQuote.source
                                ? citedQuote.source
                                : "Error Fecthing Quotes"}
                            </em>
                          </li>
                        )
                      )
                      : "Not enough online presence found"}
                  </ul>
                </div> */}
                {/* <div className="keyProductFeatures scoring">
                  <h5>Scoring</h5>
                  <h6>
                    {scoring &&
                      scoring.ourBrand &&
                      scoring.ourBrand.productAnalysis &&
                      scoring.ourBrand.productAnalysis.score + " out of 100"}
                  </h6>
                  <p>
                    {scoring &&
                      scoring.ourBrand &&
                      scoring.ourBrand.productAnalysis &&
                      scoring.ourBrand.productAnalysis.reason}
                  </p>
                </div> */}
              </div>
            </p>
            <div className="d-flex gap-2">
              <div className="CustomerRetentionRates-txt-container"></div>
              <div className="CustomerRetentionRates-progress-container"></div>
            </div>
          </div>

          <div className="GenerateReport-fourGridStats-box">
            <h5>Brand Positioning</h5>
            <div className="d-flex gap-2">
              <div className="WebsiteAnalytics-txt-container">
                <p>
                  <div className="productAnalysisContent">
                    {/* <div className="keyProductFeatures">
                      <h5>Commercialization Strategies</h5>
                      <ul>
                        {ourBrand.mainAnalysis &&
                          ourBrand.mainAnalysis.brandInformation &&
                          ourBrand.mainAnalysis.brandInformation
                            .commercializationAnalysis &&
                          ourBrand.mainAnalysis.brandInformation
                            .commercializationAnalysis
                            .keyCommercializationStrategies
                          ? ourBrand.mainAnalysis.brandInformation.commercializationAnalysis.keyCommercializationStrategies.map(
                            (strategy) => (
                              <li>
                                <Icon
                                  icon="solar:map-arrow-right-bold-duotone"
                                  width="20"
                                  height="20"
                                />
                                {strategy}
                              </li>
                            )
                          )
                          : "Some Error Occured"}
                      </ul>
                    </div> */}
                    <div className="keyProductFeatures">
                      <h5 style={{ backgroundColor: "#211B3F" }}>Key Brand Positioning Points</h5>
                      <ul>
                        {ourBrand.mainAnalysis &&
                          ourBrand.mainAnalysis.brandInformation &&
                          ourBrand.mainAnalysis.brandInformation
                            .brandPositioning
                          &&
                          ourBrand.mainAnalysis.brandInformation
                            .brandPositioning

                            .brandPositioningAnalysisPoints
                          ? ourBrand.mainAnalysis.brandInformation.brandPositioning
                            .brandPositioningAnalysisPoints.map(
                              (differntiators) => (
                                <li>
                                  <Icon
                                    icon="solar:map-arrow-right-bold-duotone"
                                    width="20"
                                    height="20"
                                  />
                                  {differntiators}
                                </li>
                              )
                            )
                          : "Some Error Occured"}
                      </ul>
                    </div>
                    {/* <div className="keyProductFeatures">
                      <h5>Quotes about Commercialization Strategies</h5>
                      <ul>
                        {ourBrand.mainAnalysis &&
                          ourBrand.mainAnalysis.brandInformation &&
                          ourBrand.mainAnalysis.brandInformation
                            .commercializationAnalysis &&
                          ourBrand.mainAnalysis.brandInformation
                            .commercializationAnalysis.citedQuotes && ourBrand.mainAnalysis.brandInformation
                              .commercializationAnalysis.citedQuotes && ourBrand.mainAnalysis.brandInformation
                                .commercializationAnalysis.citedQuotes.length > 0
                          ? ourBrand.mainAnalysis.brandInformation.commercializationAnalysis.citedQuotes.map(
                            (citedQuote) => (
                              <li>
                                <Icon
                                  icon="solar:map-arrow-right-bold-duotone"
                                  width="20"
                                  height="20"
                                />
                                {citedQuote && citedQuote.quote
                                  ? citedQuote.quote
                                  : "Error Fecthing Quotes"}
                                <em>
                                  {citedQuote &&
                                    citedQuote.quote &&
                                    citedQuote.source
                                    ? " - "
                                    : ""}
                                  {citedQuote && citedQuote.source
                                    ? citedQuote.source
                                    : "Error Fecthing Quotes"}
                                </em>
                              </li>
                            )
                          )
                          : "Not enough online presence found"}
                      </ul>
                    </div> */}
                    {/* <div className="keyProductFeatures scoring">
                      <h5>Scoring</h5>
                      <h6>
                        {scoring &&
                          scoring.ourBrand &&
                          scoring.ourBrand.commercializationAnalysis &&
                          scoring.ourBrand.commercializationAnalysis.score +
                            " out of 100"}
                      </h6>
                      <p>
                        {scoring &&
                          scoring.ourBrand &&
                          scoring.ourBrand.commercializationAnalysis &&
                          scoring.ourBrand.commercializationAnalysis.reason}
                      </p>
                    </div> */}
                  </div>
                </p>
              </div>
              {/* <div className="WebsiteAnalytics-progress-container">
                <OverAllChart />
              </div> */}
            </div>
          </div>
          <div className="GenerateReport-fourGridStats-box">
            <h5>Product Features Analysis</h5>
            <p>
              <div className="productAnalysisContent">
                <div className="keyProductFeatures">
                  <h5>Key Product Features</h5>
                  <ul>
                    {ourBrand.mainAnalysis &&
                      ourBrand.mainAnalysis.brandInformation &&
                      ourBrand.mainAnalysis.brandInformation
                        .productFeaturesAnalysis &&
                      ourBrand.mainAnalysis.brandInformation
                        .productFeaturesAnalysis.keyProductFeatures
                      ? ourBrand.mainAnalysis.brandInformation.productFeaturesAnalysis.keyProductFeatures.map(
                        (feature) => (
                          <li>
                            <Icon
                              icon="solar:map-arrow-right-bold-duotone"
                              width="20"
                              height="20"
                            />
                            {feature}
                          </li>
                        )
                      )
                      : "Some Error Occured"}
                  </ul>
                </div>
                <div className="keyProductFeatures">
                  <h5>Interesting Product Differentiations</h5>
                  <ul>
                    {ourBrand.mainAnalysis &&
                      ourBrand.mainAnalysis.brandInformation &&
                      ourBrand.mainAnalysis.brandInformation
                        .productFeaturesAnalysis &&
                      ourBrand.mainAnalysis.brandInformation
                        .productFeaturesAnalysis.interestingProductDifferntiators
                      ? ourBrand.mainAnalysis.brandInformation.productFeaturesAnalysis.interestingProductDifferntiators.map(
                        (differntiators) => (
                          <li>
                            <Icon
                              icon="solar:map-arrow-right-bold-duotone"
                              width="20"
                              height="20"
                            />
                            {differntiators}
                          </li>
                        )
                      )
                      : "Some Error Occured"}
                  </ul>
                </div>
                <div className="keyProductFeatures">
                  <h5>Quotes about Product Features</h5>
                  <ul>
                    {ourBrand.mainAnalysis &&
                      ourBrand.mainAnalysis.brandInformation &&
                      ourBrand.mainAnalysis.brandInformation
                        .productFeaturesAnalysis &&
                      ourBrand.mainAnalysis.brandInformation
                        .productFeaturesAnalysis.citedQuotes && ourBrand.mainAnalysis.brandInformation.productFeaturesAnalysis.citedQuotes.length > 0
                      ? ourBrand.mainAnalysis.brandInformation.productFeaturesAnalysis.citedQuotes.map(
                        (citedQuote) => (
                          <li>
                            <Icon
                              icon="solar:map-arrow-right-bold-duotone"
                              width="20"
                              height="20"
                            />
                            {citedQuote && citedQuote.quote
                              ? citedQuote.quote
                              : "Error Fecthing Quotes"}
                            <em>
                              {citedQuote &&
                                citedQuote.quote &&
                                citedQuote.source
                                ? " - "
                                : ""}
                              {citedQuote && citedQuote.source
                                ? citedQuote.source
                                : "Error Fecthing Quotes"}
                            </em>
                          </li>
                        )
                      )
                      : "Not enough online presence found"}
                  </ul>
                </div>
                {/* <div className="keyProductFeatures scoring">
                  <h5>Scoring</h5>
                  <h6>
                    {scoring &&
                      scoring.ourBrand &&
                      scoring.ourBrand.productAnalysis &&
                      scoring.ourBrand.productAnalysis.score + " out of 100"}
                  </h6>
                  <p>
                    {scoring &&
                      scoring.ourBrand &&
                      scoring.ourBrand.productAnalysis &&
                      scoring.ourBrand.productAnalysis.reason}
                  </p>
                </div> */}
              </div>
            </p>
            <div className="d-flex gap-2">
              <div className="CustomerRetentionRates-txt-container"></div>
              <div className="CustomerRetentionRates-progress-container"></div>
            </div>
          </div>

          <div className="GenerateReport-fourGridStats-box">
            <h5>Commercialization Strategies</h5>
            <div className="d-flex gap-2">
              <div className="WebsiteAnalytics-txt-container">
                <p>
                  <div className="productAnalysisContent">
                    <div className="keyProductFeatures">
                      <h5>Commercialization Strategies</h5>
                      <ul>
                        {ourBrand.mainAnalysis &&
                          ourBrand.mainAnalysis.brandInformation &&
                          ourBrand.mainAnalysis.brandInformation
                            .commercializationAnalysis &&
                          ourBrand.mainAnalysis.brandInformation
                            .commercializationAnalysis
                            .keyCommercializationStrategies
                          ? ourBrand.mainAnalysis.brandInformation.commercializationAnalysis.keyCommercializationStrategies.map(
                            (strategy) => (
                              <li>
                                <Icon
                                  icon="solar:map-arrow-right-bold-duotone"
                                  width="20"
                                  height="20"
                                />
                                {strategy}
                              </li>
                            )
                          )
                          : "Some Error Occured"}
                      </ul>
                    </div>
                    <div className="keyProductFeatures">
                      <h5>Interesting Commercialization Differentiations</h5>
                      <ul>
                        {ourBrand.mainAnalysis &&
                          ourBrand.mainAnalysis.brandInformation &&
                          ourBrand.mainAnalysis.brandInformation
                            .commercializationAnalysis &&
                          ourBrand.mainAnalysis.brandInformation
                            .commercializationAnalysis
                            .interestingCommercializationDifferntiators
                          ? ourBrand.mainAnalysis.brandInformation.commercializationAnalysis.interestingCommercializationDifferntiators.map(
                            (differntiators) => (
                              <li>
                                <Icon
                                  icon="solar:map-arrow-right-bold-duotone"
                                  width="20"
                                  height="20"
                                />
                                {differntiators}
                              </li>
                            )
                          )
                          : "Some Error Occured"}
                      </ul>
                    </div>
                    <div className="keyProductFeatures">
                      <h5>Quotes about Commercialization Strategies</h5>
                      <ul>
                        {ourBrand.mainAnalysis &&
                          ourBrand.mainAnalysis.brandInformation &&
                          ourBrand.mainAnalysis.brandInformation
                            .commercializationAnalysis &&
                          ourBrand.mainAnalysis.brandInformation
                            .commercializationAnalysis.citedQuotes && ourBrand.mainAnalysis.brandInformation
                              .commercializationAnalysis.citedQuotes && ourBrand.mainAnalysis.brandInformation
                                .commercializationAnalysis.citedQuotes.length > 0
                          ? ourBrand.mainAnalysis.brandInformation.commercializationAnalysis.citedQuotes.map(
                            (citedQuote) => (
                              <li>
                                <Icon
                                  icon="solar:map-arrow-right-bold-duotone"
                                  width="20"
                                  height="20"
                                />
                                {citedQuote && citedQuote.quote
                                  ? citedQuote.quote
                                  : "Error Fecthing Quotes"}
                                <em>
                                  {citedQuote &&
                                    citedQuote.quote &&
                                    citedQuote.source
                                    ? " - "
                                    : ""}
                                  {citedQuote && citedQuote.source
                                    ? citedQuote.source
                                    : "Error Fecthing Quotes"}
                                </em>
                              </li>
                            )
                          )
                          : "Not enough online presence found"}
                      </ul>
                    </div>
                    {/* <div className="keyProductFeatures scoring">
                      <h5>Scoring</h5>
                      <h6>
                        {scoring &&
                          scoring.ourBrand &&
                          scoring.ourBrand.commercializationAnalysis &&
                          scoring.ourBrand.commercializationAnalysis.score +
                            " out of 100"}
                      </h6>
                      <p>
                        {scoring &&
                          scoring.ourBrand &&
                          scoring.ourBrand.commercializationAnalysis &&
                          scoring.ourBrand.commercializationAnalysis.reason}
                      </p>
                    </div> */}
                  </div>
                </p>
              </div>
              {/* <div className="WebsiteAnalytics-progress-container">
                <OverAllChart />
              </div> */}
            </div>
          </div>
        </div>

        <div className="GenerateReport-threeGridStats-container">
          <div>
            <div className="GenerateReport-threeGridStats-box">
              <h5>Customer Feedback Response Rate</h5>
              {ourBrand.reviews ? <div className="d-flex justify-content-between px-y response-box">
                <div>
                  <span className="Feedback-txt-head">Negative</span>
                  <br />
                  <span className="Feedback-txt-perc">
                    {Math.round(
                      ((ourBrand.reviews &&
                        ourBrand.reviews.reviewDistribution &&
                        ourBrand.reviews.reviewDistribution["1"]) /
                        (ourBrand.reviews && ourBrand.reviews.totalReviews)) *
                      100
                    )}
                    %
                  </span>
                </div>
                <div>
                  <span className="Feedback-txt-head">Unsatisfactory</span>
                  <br />
                  <span className="Feedback-txt-perc">
                    {Math.round(
                      ((ourBrand.reviews &&
                        ourBrand.reviews.reviewDistribution &&
                        ourBrand.reviews.reviewDistribution["2"]) /
                        (ourBrand.reviews && ourBrand.reviews.totalReviews)) *
                      100
                    )}
                    %
                  </span>
                </div>
                <div>
                  <span className="Feedback-txt-head">Neutral</span>
                  <br />
                  <span className="Feedback-txt-perc">
                    {Math.round(
                      ((ourBrand.reviews &&
                        ourBrand.reviews.reviewDistribution &&
                        ourBrand.reviews.reviewDistribution["3"]) /
                        (ourBrand.reviews && ourBrand.reviews.totalReviews)) *
                      100
                    )}
                    %
                  </span>
                </div>
                <div>
                  <span className="Feedback-txt-head">Satisfactory</span>
                  <br />
                  <span className="Feedback-txt-perc">
                    {Math.round(
                      ((ourBrand.reviews &&
                        ourBrand.reviews.reviewDistribution &&
                        ourBrand.reviews.reviewDistribution["4"]) /
                        (ourBrand.reviews && ourBrand.reviews.totalReviews)) *
                      100
                    )}
                    %
                  </span>
                </div>
                <div>
                  <span className="Feedback-txt-head">Positive</span>
                  <br />
                  <span className="Feedback-txt-perc">
                    {Math.round(
                      ((ourBrand.reviews &&
                        ourBrand.reviews.reviewDistribution &&
                        ourBrand.reviews.reviewDistribution["5"]) /
                        (ourBrand.reviews && ourBrand.reviews.totalReviews)) *
                      100
                    )}
                    %
                  </span>
                </div>
              </div>
                :
                <p> This Brand doesn't have enough online presence or reviews.</p>}
              {/* <p className="pt-2">
                                Vivamus eget lorem non velit scelerisque sollicitudin. Nulla
                                facilisi. Etiam ac porta est, id sagittis diam. Vivamus et
                                sollicitudin sapien. Phasellus at ante in massa mollis bibendum
                                sit amet quis lectus. Maecenas rhoncus consequat sollicitudin.
                                In eleifend cursus lacus, in suscipit leo dictum eu. Sed blandit
                                tincidunt dui.
                            </p> */}
            </div>

            <div className="GenerateReport-threeGridStats-box mt-3">
              <h5>Brand Attributes Analysis</h5>
              <div className="productAnalysisContent">
                <div className="keyProductFeatures">
                  <h5>Key Brand Attributes</h5>
                  <ul>
                    {ourBrand.mainAnalysis &&
                      ourBrand.mainAnalysis.brandInformation &&
                      ourBrand.mainAnalysis.brandInformation
                        .brandAttributesAnalysis &&
                      ourBrand.mainAnalysis.brandInformation
                        .brandAttributesAnalysis.keyBrandAttributes
                      ? ourBrand.mainAnalysis.brandInformation.brandAttributesAnalysis.keyBrandAttributes.map(
                        (attribute) => (
                          <li>
                            <Icon
                              icon="solar:map-arrow-right-bold-duotone"
                              width="20"
                              height="20"
                            />
                            {attribute}
                          </li>
                        )
                      )
                      : "Some Error Occured"}
                  </ul>
                </div>
                <div className="keyProductFeatures">
                  <h5>Interesting Brand Differentiations</h5>
                  <ul>
                    {ourBrand.mainAnalysis &&
                      ourBrand.mainAnalysis.brandInformation &&
                      ourBrand.mainAnalysis.brandInformation
                        .brandAttributesAnalysis &&
                      ourBrand.mainAnalysis.brandInformation
                        .brandAttributesAnalysis
                        .interestingBrandAttributesDifferntiators
                      ? ourBrand.mainAnalysis.brandInformation.brandAttributesAnalysis.interestingBrandAttributesDifferntiators.map(
                        (differntiators) => (
                          <li>
                            <Icon
                              icon="solar:map-arrow-right-bold-duotone"
                              width="20"
                              height="20"
                            />
                            {differntiators}
                          </li>
                        )
                      )
                      : "Some Error Occured"}
                  </ul>
                </div>
                <div className="keyProductFeatures">
                  <h5>Quotes about Brand Attributes</h5>
                  <ul>
                    {ourBrand.mainAnalysis &&
                      ourBrand.mainAnalysis.brandInformation &&
                      ourBrand.mainAnalysis.brandInformation
                        .brandAttributesAnalysis &&
                      ourBrand.mainAnalysis.brandInformation
                        .brandAttributesAnalysis.citedQuotes && ourBrand.mainAnalysis.brandInformation
                          .brandAttributesAnalysis.citedQuotes.length > 0
                      ? ourBrand.mainAnalysis.brandInformation.brandAttributesAnalysis.citedQuotes.map(
                        (citedQuote) => (
                          <li>
                            <Icon
                              icon="solar:map-arrow-right-bold-duotone"
                              width="20"
                              height="20"
                            />
                            {citedQuote && citedQuote.quote
                              ? citedQuote.quote
                              : "Error Fecthing Quotes"}
                            <em>
                              {citedQuote &&
                                citedQuote.quote &&
                                citedQuote.source
                                ? " - "
                                : ""}
                              {citedQuote && citedQuote.source
                                ? citedQuote.source
                                : "Error Fecthing Quotes"}
                            </em>
                          </li>
                        )
                      )
                      : "Not enough online presence found"}
                  </ul>
                </div>
                {/* <div className="keyProductFeatures scoring">
                  <h5>Scoring</h5>
                  <h6>
                    {scoring &&
                      scoring.ourBrand &&
                      scoring.ourBrand.brandAttribute &&
                      scoring.ourBrand.brandAttribute.score + " out of 100"}
                  </h6>
                  <p>
                    {scoring &&
                      scoring.ourBrand &&
                      scoring.ourBrand.brandAttribute &&
                      scoring.ourBrand.brandAttribute.reason}
                  </p>
                </div> */}
              </div>
              {/* <div className='CustomeRatingReviews-container'>
                                <div className='w-50'>
                                    <h6>Reviews</h6>
                                    <p>Duis tincidunt rutrum pharetra. Ut faucibus ante id diam egestas blandit.</p>
                                </div>
                                <div className='w-50'>
                                    <span className='d-flex align-items-center mb-2'>
                                        <p style={{ color: "#000" }} className='d-flex align-items-center'>3<Icon icon="bi:star-fill" color='#000' width={10} height={10} style={{ marginLeft: "3px", marginTop: "-2px" }} /></p>
                                        <div className='CustomeRatingReviews-box'></div>
                                    </span>
                                    <span className='d-flex align-items-center mb-2'>
                                        <p style={{ color: "#000" }} className='d-flex align-items-center'>5<Icon icon="bi:star-fill" color='#000' width={10} height={10} style={{ marginLeft: "3px", marginTop: "-2px" }} /></p>
                                        <div className='CustomeRatingReviews-box2'></div>
                                    </span>
                                </div>
                            </div> */}
              <div className="CustomeRatingReviews-container">
                <div className="mt-3">
                  {/* <h6>Ratings</h6>
                                    <div className='d-flex align-items-center'>
                                        <p className='pr-5' style={{ color: "#000", paddingRight: "10px" }}>Overall</p>
                                        <div className='rating-star-container'>
                                            <Icon icon="bi:star-fill" color='#FFD700' width={15} height={15} style={{ marginLeft: "5px", marginTop: "-2px" }} />
                                            <Icon icon="bi:star-fill" color='#FFD700' width={15} height={15} style={{ marginLeft: "5px", marginTop: "-2px" }} />
                                            <Icon icon="bi:star-fill" color='#FFD700' width={15} height={15} style={{ marginLeft: "5px", marginTop: "-2px" }} />
                                            <Icon icon="bi:star-fill" color='#FFD700' width={15} height={15} style={{ marginLeft: "5px", marginTop: "-2px" }} />
                                            <Icon icon="bi:star-fill" color='#FFD700' width={15} height={15} style={{ marginLeft: "5px", marginTop: "-2px" }} />
                                        </div>
                                        <p style={{ color: "#000", paddingLeft: "10px" }}>5</p>
                                    </div>
                                    <p>Pellentesque vel diam quis nisl laoreet consequat id vitae massa. Mauris tempor nunc ut pellentesque interdum.</p> */}
                </div>
              </div>
            </div>
          </div>

          <div className="GenerateReport-threeGridStats-box">
            <h5>Marketing Analysis</h5>
            <div className="productAnalysisContent">
              <div className="keyProductFeatures">
                <h5>Key Marketing Strategies</h5>
                <ul>
                  {ourBrand.mainAnalysis &&
                    ourBrand.mainAnalysis.brandInformation &&
                    ourBrand.mainAnalysis.brandInformation.marketingAnalysis &&
                    ourBrand.mainAnalysis.brandInformation.marketingAnalysis
                      .keyMarketingStrategies
                    ? ourBrand.mainAnalysis.brandInformation.marketingAnalysis.keyMarketingStrategies.map(
                      (strategy) => (
                        <li>
                          <Icon
                            icon="solar:map-arrow-right-bold-duotone"
                            width="20"
                            height="20"
                          />
                          {strategy}
                        </li>
                      )
                    )
                    : "Some Error Occured"}
                </ul>
              </div>
              <div className="keyProductFeatures">
                <h5>Interesting Marketing Differentiations</h5>
                <ul>
                  {ourBrand.mainAnalysis &&
                    ourBrand.mainAnalysis.brandInformation &&
                    ourBrand.mainAnalysis.brandInformation.marketingAnalysis &&
                    ourBrand.mainAnalysis.brandInformation.marketingAnalysis
                      .interestingMarketingStrategiesDifferntiators
                    ? ourBrand.mainAnalysis.brandInformation.marketingAnalysis.interestingMarketingStrategiesDifferntiators.map(
                      (differntiators) => (
                        <li>
                          <Icon
                            icon="solar:map-arrow-right-bold-duotone"
                            width="20"
                            height="20"
                          />
                          {differntiators}
                        </li>
                      )
                    )
                    : "Some Error Occured"}
                </ul>
              </div>
              <div className="keyProductFeatures">
                <h5>Quotes about Marketing Strategies</h5>
                <ul>
                  {ourBrand.mainAnalysis &&
                    ourBrand.mainAnalysis.brandInformation &&
                    ourBrand.mainAnalysis.brandInformation.marketingAnalysis &&
                    ourBrand.mainAnalysis.brandInformation.marketingAnalysis
                      .citedQuotes && ourBrand.mainAnalysis.brandInformation.marketingAnalysis
                        .citedQuotes.length > 0
                    ? ourBrand.mainAnalysis.brandInformation.marketingAnalysis.citedQuotes.map(
                      (citedQuote) => (
                        <li>
                          <Icon
                            icon="solar:map-arrow-right-bold-duotone"
                            width="20"
                            height="20"
                          />
                          {citedQuote && citedQuote.quote
                            ? citedQuote.quote
                            : "Error Fecthing Quotes"}
                          <em>
                            {citedQuote &&
                              citedQuote.quote &&
                              citedQuote.source
                              ? " - "
                              : ""}
                            {citedQuote && citedQuote.source
                              ? citedQuote.source
                              : "Error Fecthing Quotes"}
                          </em>
                        </li>
                      )
                    )
                    : "Not enough online presence found"}
                </ul>
              </div>
              {/* <div className="keyProductFeatures scoring">
                <h5>Scoring</h5>
                <h6>
                  {scoring &&
                    scoring.ourBrand &&
                    scoring.ourBrand.marketingAnalysis &&
                    scoring.ourBrand.marketingAnalysis.score + " out of 100"}
                </h6>
                <p>
                  {scoring &&
                    scoring.ourBrand &&
                    scoring.ourBrand.marketingAnalysis &&
                    scoring.ourBrand.marketingAnalysis.reason}
                </p>
              </div> */}
            </div>
          </div>
        </div>

        <div className="GenerateReport-ProductPerformanceMetrics-container">
          <div className="w-100 salseAndRevenue-full">
            <h5>Customer Experience (CX) Analysis</h5>
            <p>
              <div className="productAnalysisContent">
                <div className="keyProductFeatures">
                  <h5>Key CX Strategies</h5>
                  <ul>
                    {ourBrand.mainAnalysis &&
                      ourBrand.mainAnalysis.brandInformation &&
                      ourBrand.mainAnalysis.brandInformation
                        .customerExperienceAnalysis &&
                      ourBrand.mainAnalysis.brandInformation
                        .customerExperienceAnalysis.keyCxStrategies
                      ? ourBrand.mainAnalysis.brandInformation.customerExperienceAnalysis.keyCxStrategies.map(
                        (strategy) => (
                          <li>
                            <Icon
                              icon="solar:map-arrow-right-bold-duotone"
                              width="20"
                              height="20"
                            />
                            {strategy}
                          </li>
                        )
                      )
                      : "Some Error Occured"}
                  </ul>
                </div>
                <div className="keyProductFeatures">
                  <h5>Interesting CX Differentiations</h5>
                  <ul>
                    {ourBrand.mainAnalysis &&
                      ourBrand.mainAnalysis.brandInformation &&
                      ourBrand.mainAnalysis.brandInformation
                        .customerExperienceAnalysis &&
                      ourBrand.mainAnalysis.brandInformation
                        .customerExperienceAnalysis.interestingCxDifferntiators
                      ? ourBrand.mainAnalysis.brandInformation.customerExperienceAnalysis.interestingCxDifferntiators.map(
                        (differntiators) => (
                          <li>
                            <Icon
                              icon="solar:map-arrow-right-bold-duotone"
                              width="20"
                              height="20"
                            />
                            {differntiators}
                          </li>
                        )
                      )
                      : "Some Error Occured"}
                  </ul>
                </div>
                <div className="keyProductFeatures">
                  <h5>Quotes about Customer Experience</h5>
                  <ul>
                    {ourBrand.mainAnalysis &&
                      ourBrand.mainAnalysis.brandInformation &&
                      ourBrand.mainAnalysis.brandInformation
                        .customerExperienceAnalysis &&
                      ourBrand.mainAnalysis.brandInformation
                        .customerExperienceAnalysis.citedQuotes && ourBrand.mainAnalysis.brandInformation
                          .customerExperienceAnalysis.citedQuotes.length > 0
                      ? ourBrand.mainAnalysis.brandInformation.customerExperienceAnalysis.citedQuotes.map(
                        (citedQuote) => (
                          <li>
                            <Icon
                              icon="solar:map-arrow-right-bold-duotone"
                              width="20"
                              height="20"
                            />
                            {citedQuote && citedQuote.quote
                              ? citedQuote.quote
                              : "Error Fecthing Quotes"}
                            <em>
                              {citedQuote &&
                                citedQuote.quote &&
                                citedQuote.source
                                ? " - "
                                : ""}
                              {citedQuote && citedQuote.source
                                ? citedQuote.source
                                : "Error Fecthing Quotes"}
                            </em>
                          </li>
                        )
                      )
                      : "Not enough online presence found"}
                  </ul>
                </div>
                {/* <div className="keyProductFeatures scoring">
                  <h5>Scoring</h5>
                  <h6>
                    {scoring &&
                      scoring.ourBrand &&
                      scoring.ourBrand.cxAnalysis &&
                      scoring.ourBrand.cxAnalysis.score + " out of 100"}
                  </h6>
                  <p>
                    {scoring &&
                      scoring.ourBrand &&
                      scoring.ourBrand.cxAnalysis &&
                      scoring.ourBrand.cxAnalysis.reason}
                  </p>
                </div> */}
              </div>
            </p>
            {/* <div className="d-flex justify-content-between align-items-center gap-3  salseAndRevenue-full-per">
              <h2 className="ProductPerformanceMetrics-h2-perc">30%</h2>
              <p className="ProductPerformanceMetrics-p-perc">
                Your product performance is 30% better compare to last month
              </p>
            </div> */}
          </div>
          {/* <div className="w-50 salseAndRevenue-full-graph">
            <MetricsChart />
          </div> */}
        </div>

        {/* <div className='GenerateReport-ProductPerformanceMetrics-container'>
                    <div className='GrowthPercentage-txt-container'>
                        <h5>Growth Percentage</h5>
                        <p>Duis imperdiet tempus leo a feugiat. Morbi semper id neque at gravida. Suspendisse et aliquam nunc, placerat volutpat tortor. Pellentesque  enim vel aliquam. Aliquam erat volutpat.</p>
                        <ul>
                            <li>
                        <Icon
                          icon="solar:map-arrow-right-bold-duotone"
                          width="20"
                          height="20"
                        />Your Weight</li>
                            <li>
                        <Icon
                          icon="solar:map-arrow-right-bold-duotone"
                          width="20"
                          height="20"
                        />Ideal Weight</li>
                        </ul>
                    </div>
                    <div className='GrowthPercentage-graph-container'>
                        <SplimeChart />
                    </div>
                </div> */}
      </div>
      {/* <div className="downloadbtn">
                <button className='dark-theme-btn'>
                    Download PDF
                </button>
            </div> */}
    </div>
  );
};

export default GenerateReport;
